import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const TestimonialSection = () => {
  return (
    <section className="bg-white md:my-[40px] my-[20px] py-10">
      <div className="mx-auto px-4">
        <h2 className="text-3xl font-arbutus text-center mb-[20px]">
          What Our Moms Say
        </h2>
        <style>
          {`
            .testimonial-swiper .swiper-slide {
              opacity: 0.2; /* Inactive slides have opacity-20 */
            }
            .testimonial-swiper .swiper-slide-active {
              opacity: 1; /* Active slide has full opacity */
            }
          `}
        </style>
        <Swiper
          modules={[Pagination, Autoplay]}
          loop={true}
          spaceBetween={20}
          slidesPerView={1}
          centeredSlides={true}
          initialSlide={0}
          // pagination={{ clickable: true }} // Uncomment if you want pagination dots
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          breakpoints={{
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
              initialSlide: 1,
            },
          }}
          className="w-full testimonial-swiper" // Added unique class
        >
          {[...Array(4)].map((_, index) => (
            <SwiperSlide key={index}>
              <div className="flex justify-center">
                <div className="space-y-[20px] bg-gradient-to-br from-yellow-100 via-yellow-50 to-yellow-100 rounded-3xl p-10 relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="49"
                    height="35"
                    viewBox="0 0 49 35"
                    fill="none"
                    className="absolute top-4 left-4"
                  >
                    <path
                      d="M29.8203 33.2832L27.6348 30.1064L27.2549 29.5557L27.8916 29.3477C32.6164 27.8069 35.7648 25.738 37.4434 23.1943L37.4453 23.1904C37.7919 22.6759 38.0427 22.2359 38.2051 21.8672C38.3698 21.4932 38.4306 21.2234 38.4307 21.041C38.4307 19.3206 37.9607 18.2528 37.1572 17.668C36.131 16.9805 35.2939 16.3472 34.6523 15.7686L34.4131 15.5586C33.8642 15.0642 33.3755 14.5312 32.9482 13.959C31.8512 12.4899 31.3135 10.7145 31.3135 8.66113C31.3135 6.57675 32.1736 4.69499 33.832 3.0293C35.4765 1.37776 37.2401 0.500021 39.1162 0.5C42.1983 0.5 44.592 1.43986 46.2002 3.3916L46.2031 3.39551C47.75 5.31278 48.5 7.81649 48.5 10.8574C48.4999 16.8715 46.8426 21.9252 43.502 25.9834C40.1657 30.0362 35.7619 32.5386 30.3184 33.4922L30.0029 33.5479L29.8203 33.2832ZM3.77441 33.2832L1.58789 30.1064L1.20898 29.5557L1.84473 29.3477C6.56958 27.8069 9.71791 25.738 11.3965 23.1943L11.3994 23.1904C11.7458 22.6761 11.9959 22.2358 12.1582 21.8672C12.3229 21.4932 12.3838 21.2234 12.3838 21.041C12.3838 19.3205 11.914 18.2527 11.1104 17.668C10.0841 16.9805 9.24704 16.3472 8.60547 15.7686L8.36621 15.5586C7.81746 15.0643 7.3286 14.5311 6.90137 13.959C5.80444 12.4899 5.26758 10.7144 5.26758 8.66113C5.26763 6.57675 6.12672 4.69499 7.78516 3.0293C9.42957 1.37775 11.1932 0.500134 13.0693 0.5C16.1514 0.5 18.5451 1.43986 20.1533 3.3916L20.1562 3.39551C21.7031 5.31278 22.4531 7.81648 22.4531 10.8574C22.453 16.8714 20.7966 21.9252 17.4561 25.9834C14.1199 30.0363 9.71601 32.5385 4.27246 33.4922L3.95605 33.5479L3.77441 33.2832Z"
                      stroke="black"
                    />
                  </svg>
                  <p className="font-arbutus text-[#202020] leading-relaxed text-[14px]">
                    "Finding maternity clothes that were both stylish and actually comfortable felt impossible—until I discovered Luna Leaf. It's like being hugged by your clothes."
                  </p>
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" />
                      </svg>
                    ))}
                  </div>
                  <p className="font-arbutus text-gray-600 text-lg">
                    — Ananya R., Bangalore
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;